import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { Link } from "react-router-dom";


function Task(props) {
    return(
        <Grid item xs={12} md={6} lg={4} xl={2}>
            <Card>
                <CardContent>
                    <Typography variant="h5" component="div">
                        {props.content.titulo}
                        {props.content.completado ? <span className="material-icons-round task-icon done">check_circle</span> 
                        :props.content.urgente ?  <span className="material-icons-round task-icon alert">warning</span>
                        : <span className="material-icons-round task-icon incomplete">pending</span> }
                    </Typography>
                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                        {props.content.descripcion}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Link to={`/proceso/${props.content.idProceso}`} onClick={() => props.setOpenCaseInfo(props.content)}
                          className="no-link">
                        <Button size="small">{props.content.proceso}</Button>
                    </Link>
                    <Link to={`/work/${props.content.idTarea}`} className="no-link">
                        <Button size="small">Ver tarea</Button>
                    </Link>
                </CardActions> 
            </Card>
        </Grid>
    )
}

export { Task };